import { Button, Group } from '@mantine/core'

// #1078 フォーム末尾の送信/キャンセル。<form> の中にマウントする前提で、
// type="submit" のボタンは囲んでいる Rails のフォームをそのまま送信する。
export default function FormActions({ submitLabel = '保存する', cancelHref, cancelLabel = 'キャンセル', align = 'center' }) {
  return (
    <Group justify={align} gap="md" mt="xs" wrap="wrap">
      {cancelHref && (
        <Button component="a" href={cancelHref} variant="default" size="md" miw={140}>
          {cancelLabel}
        </Button>
      )}
      <Button type="submit" size="md" miw={180}>
        {submitLabel}
      </Button>
    </Group>
  )
}
